import { Flex, Text } from 'components'
import { useBreakpoint } from 'utils'
import { AIPanel, SmartColumnPanel } from '../components'

export default function IntelligencePage() {
  const breakpoint = useBreakpoint()

  return (
    <Flex
      direction="column"
      gap={4}
      flex="auto"
      p={breakpoint < 2 ? 4 : 0}
      pb={3}
      pr={5}
      overflowY="auto"
      overflowX="hidden"
    >
      <Text textStyle="h3" pt={2}>
        Intelligence
      </Text>
      <AIPanel />
      <SmartColumnPanel />
    </Flex>
  )
}
